var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  pluginRegistry.registerFeature("Octopus.Features.IisHome", function(busy, octopusRepository) {
    return {
      title: "IIS6+ home directory",
      description: "Points an existing IIS website or virtual directory's 'Home' directory to the path the package was extracted to (**not** compatible with the _IIS web site_ feature)",
      editTemplateUrl: "areas/projects/features/Octopus.Features.IisHome_edit.html",
      priority: 30,
      editLink: function($scope, element) {
      },
      enable: function(action, step) {
        action.Properties["Octopus.Action.Package.UpdateIisWebsite"] = "True";
      },
      disable: function(action, step) {
        delete action.Properties["Octopus.Action.Package.UpdateIisWebsite"];
        delete action.Properties["Octopus.Action.Package.UpdateIisWebsiteName"];
      }
    };
  });

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.IisHome.js
// module id = 561
// module chunks = 1